import { Component, OnInit } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';
import { AlbaranService } from '../../services/albaran.service';
import { ConfigurationService, TurnoService } from 'src/app/core';
import { shareReplay, mergeMap, take } from 'rxjs/operators';
import { PrintService } from 'src/app/shared/services/print.service';
import { DevolucionService } from '../../services/devolucion.service';
import { FacturaService } from 'src/app/shared/services/factura.service';
import { Router } from '@angular/router';
import { PagoService } from 'src/app/modules/venta/services/pago.service';
import { AlbaranRecinto } from '../../models/albaran.model';
import { GestorEfectivoService } from 'src/app/core/hardware/gestor-efectivo/gestorEfectivo.service';
import {
  normalizeCashKeeperError,
  CASHKEEPER_ERROR_DEFAULT,
  getErrorMessage,
  extractDescriptionCashKeeper,
} from 'src/app/core/hardware/gestor-efectivo/cashkeeper-codigos';
import { TranslateService } from 'src/app/shared/services/translate.service';
import { ToastrService } from 'ngx-toastr';
import { ErrorToast } from 'src/app/core/toast/error.toast';

@Component({
  selector: 'ticketing-resumen-venta',
  templateUrl: './resumen-venta.component.html',
  styleUrls: ['./resumen-venta.component.scss'],
  // tslint:disable-next-line:use-host-property-decorator
  host: {
    class: 'col-resumen'
  }
})
export class ResumenVentaComponent implements OnInit {
  albaran$: Observable<any>;
  valoresImpresion$: Observable<any>;
  divisaSimboloDecimal: string; 
  divisaSimbSeparacionMiles: string;  
  divisaSimbolo: string;
  divisaDecimales: number;
  divisaPosicion: string;
  divisaSimboloDerecha: string;
  esGranDivisa: boolean;
  habilitarDevolucion = false;
  cantidadProductos = 0;
  recintos$: Observable<any>;
  recintos: AlbaranRecinto[];


  constructor(
    private albaranService: AlbaranService,
    private configuration: ConfigurationService,
    private devolucionService: DevolucionService,
    private printService: PrintService,
    private facturaService: FacturaService,
    private router: Router,
    private turnoService: TurnoService,
    private pagoService: PagoService,
    private gestorEfectivoService: GestorEfectivoService,
    private translateService: TranslateService,
    private toast: ToastrService
  ) {
  }

  ngOnInit() {
    this.divisaSimbSeparacionMiles = this.configuration.divisasValue[0].SimbSeparacionMiles;
    this.divisaSimboloDecimal = this.configuration.divisasValue[0].SimboloDecimal;
    this.divisaSimbolo = this.configuration.divisasValue[0].simbolo;
    this.divisaDecimales = Number(this.configuration.divisasValue[0].NumeroDecimales)
    this.divisaPosicion = this.configuration.divisasValue[0].PosicionDivisa;
    this.divisaSimboloDerecha = this.configuration.divisasValue[0].SimboloDerecha;
    this.albaran$ = this.albaranService.albaran.pipe(shareReplay(5));
    this.valoresImpresion$ = this.printService.opcionesDeImpresion;
    this.recintos$ = this.albaranService.albaran;
    this.recintos$.subscribe((data: any) => {
      if (data !== null && data !== undefined) {
        this.filtrarRecintos(data.AlbaranRecintos);
      }
    });
    this.albaranService.albaran.subscribe(data => {
      if (data !== null && data !== undefined) {
        this.cantidadProductos = 0;
        data.AlbaranItems.forEach(element => {
          // CORRECCIÓN: Para promociones (TipoProducto === '2'), contar como 1 unidad por promoción
          if (element.TipoProducto === '2') {
            // Contar solo la cantidad de promociones, no las entradas individuales
            const cantidadPromociones = Number.parseInt(element.Cantidad, 10);
            this.cantidadProductos += cantidadPromociones;
          } else {
            // Para productos normales, usar la cantidad directamente
            this.cantidadProductos += Number.parseInt(element.Cantidad, 10);
          }
        });
        
        // 
        // // this.recintos = data.AlbaranRecintos.map(recinto => this.filtrarRecintos(recinto,data.AlbaranRecintos));
        // this.recintos$ = data.AlbaranRecintos;
        // 
        // this.recintos = data.AlbaranRecintos.map(recinto => this.filtrarRecintos(recinto,data.AlbaranRecintos));
        // this.recintos$ = data.AlbaranRecintos;
        // this.recintos$.subscribe(data =>{
        //   this.recintos = this.filtrarRecintos(data.AlbaranRecintos);
        // 
      }
    });
    this.devolucionService.carritoDevolucion$.subscribe(carro => {
      if (carro && carro.entradas.length > 0) {
        this.habilitarDevolucion = true;
      } else {
        this.habilitarDevolucion = false;
      }
    });

  }

  conversor(precio: string) {
    return Number.parseFloat(precio.replace(/,/, '.'));
  }

  getPriceByLinea(price: string, quantity: number) {
    const precio = this.conversor(price);
    
    if (isNaN(precio) || isNaN(quantity)) {
      return 0;
    }
    
    const precioFinal = precio * quantity;

    if (isNaN(precioFinal)) {
      return 0;
    }

    return precioFinal.toFixed(2)
  }

  sePuedeFinalizar() {
    // Apaño para precio 0
    if (
      this.devolucionService.carritoDevolucion.entradas.length > 0 &&
      this.devolucionService.carritoDevolucion.precioTotal === 0
    ) {
      return false;
    }
    return (this.devolucionService.diferenciaValue
      && this.devolucionService.diferenciaValue == this.devolucionService.carritoDevolucion.precioTotal && this.devolucionService.formularioCorrectoValue)
      ? false
      : true;
  }

  async devolver() {
    this.habilitarDevolucion = false;
    let oldNumAlbaran: string = '';
    let oldAlbaranTPVid: string = '';
    // Guardar información del albarán original para determinar tipo de pago
    const albaranOriginal = this.albaranService.albaranValue;

    const pd = this.devolucionService.pagoDesglosadoValue;
    const efectivo = Number(pd?.metalico ?? pd?.efectivo) || 0;
    const centimos = Math.round(efectivo * 100);
    if (this.gestorEfectivoService.isCashManagerConnected() && centimos > 0) {
      const res = await this.gestorEfectivoService.processCashOperation('D', centimos);
      if (!res.ok) {
        this.habilitarDevolucion = true;
        const rawError = getErrorMessage(res);
        const clave = normalizeCashKeeperError(rawError);
        const traducido = this.translateService.instant(clave);
        const desc = extractDescriptionCashKeeper(rawError);
        const msg =
          traducido === clave
            ? desc || this.translateService.instant(CASHKEEPER_ERROR_DEFAULT)
            : traducido || this.translateService.instant(CASHKEEPER_ERROR_DEFAULT);
        this.toast.error(msg, '', { toastComponent: ErrorToast });
        return;
      }
    }

    if (this.albaranService.albaranValue.TienePagoCC === '1') {
      this.albaranService
        .generarIdentificadores(
          this.albaranService.albaranValue.TPVId,
          this.albaranService.albaranValue.Prefijo
        )
        .subscribe((data: any) => {
          this.albaranService
            .devolucionParcialTarjeta(
              this.devolucionService.itemsSeleccionadosValue,
              data.DatosResult.Identificador,
              data.DatosResult.NumAlbaran
            )
            .subscribe((item: any) => {
              if (item.DatosResult) {
                oldAlbaranTPVid = this.albaranService.albaranValue.TPVId;
                oldNumAlbaran = this.albaranService.albaranValue.NumAlbaran;
                
                // Verificar si el pago original fue con tarjeta PINPAD (TieneLectorElectronico === 'True' = PINPAD)
                const esPagoConPinpad = albaranOriginal?.TienePagoCC === '1' && 
                                       albaranOriginal?.PagoCCInfo?.TieneLectorElectronico === 'True';
                
                // Verificar si la devolución generó una factura (FacturaSerie y FacturaNumero presentes)
                if (item.DatosResult.FacturaSerie && item.DatosResult.FacturaNumero) {
                  // Si es PINPAD, usar GenerarTarjetaPDF en lugar de Factura/GenerarPDF
                  if (esPagoConPinpad) {
                    // Actualizar datosTarjeta con el NumAlbaran de la devolución
                    this.albaranService.refrescarAlbaran(item.DatosResult.NumAlbaran).subscribe(res => {
                      if (res) {
                        if (!this.pagoService.datosTarjeta) {
                          this.pagoService.datosTarjeta = {} as any;
                        }
                        this.pagoService.datosTarjeta.NumAlbaran = item.DatosResult.NumAlbaran;
                        this.pagoService.datosTarjeta.Identificador = this.albaranService.albaranValue.NumVenta || item.DatosResult.NumAlbaran;
                        
                        const tpvId = this.albaranService.albaranValue.TPVId || 'TPV';
                        const numVenta = this.albaranService.albaranValue.NumVenta || item.DatosResult.NumAlbaran;
                        const nombreIdentificador = `${tpvId} - ${numVenta}`;
                        
                        // Llamar a /Justificante/GenerarTarjetaPDF
                        this.pagoService.impresionTarjeta(nombreIdentificador).subscribe(
                          (response) => {
                            // CORRECCIÓN CASO 01: Agregar redirección después de impresión exitosa
                            this.albaranService.refrescarAlbaran(oldNumAlbaran).subscribe(() => {
                              this.albaranService.anulacionTotal.next(false);
                              this.devolucionService.setCarritoDevolucion(null);
                              this.devolucionService.setItemsSeleccionados(null);
                              this.devolucionService.setPagoTotal(null);
                              this.devolucionService.setPagoDesglosado(null);
                              this.devolucionService.setDiferencia(null);
                              this.devolucionService.setCambio(null);
                              this.router.navigate(['gestionar-venta']).then(() => {
                              }).catch((error) => {
                              });
                            }, (error) => {
                            });
                          },
                          (error) => {
                            // CORRECCIÓN CASO 01: Redirigir incluso si hay error en la impresión
                            this.albaranService.refrescarAlbaran(oldNumAlbaran).subscribe(() => {
                              this.albaranService.anulacionTotal.next(false);
                              this.devolucionService.setCarritoDevolucion(null);
                              this.devolucionService.setItemsSeleccionados(null);
                              this.devolucionService.setPagoTotal(null);
                              this.devolucionService.setPagoDesglosado(null);
                              this.devolucionService.setDiferencia(null);
                              this.devolucionService.setCambio(null);
                              this.router.navigate(['gestionar-venta']).then(() => {
                              }).catch((error) => {
                              });
                            }, (refreshError) => {
                            });
                          }
                        );
                      } else {
                        // CORRECCIÓN: Redirigir incluso si refrescarAlbaran retorna null/undefined
                        this.albaranService.anulacionTotal.next(false);
                        this.devolucionService.setCarritoDevolucion(null);
                        this.devolucionService.setItemsSeleccionados(null);
                        this.devolucionService.setPagoTotal(null);
                        this.devolucionService.setPagoDesglosado(null);
                        this.devolucionService.setDiferencia(null);
                        this.devolucionService.setCambio(null);
                        this.router.navigate(['gestionar-venta']).then(() => {
                        }).catch((error) => {
                        });
                      }
                    }, (error) => {
                    });
                  } else {
                    // Usar el nuevo endpoint WebAPIImpresionTaquilla/api/Factura/GenerarPDF
                    this.facturaService.generarPDFFacturaDevolucion(
                      item.DatosResult.FacturaSerie,
                      item.DatosResult.FacturaNumero
                    ).subscribe(() => {
                      this.albaranService
                        .refrescarAlbaran(this.albaranService.albaranValue.NumAlbaran)
                        .subscribe();
                      this.albaranService.anulacionTotal.next(false);
                      this.devolucionService.setCarritoDevolucion(null);
                      this.devolucionService.setPagoTotal(null);
                      this.devolucionService.setPagoDesglosado(null);
                      this.devolucionService.setDiferencia(null);
                      this.devolucionService.setCambio(null);
                      this.router.navigate(['gestionar-venta']);
                    });
                  }
                } else {
                  // CORRECCIÓN: Pasar albarán original para determinar tipo de pago (PINPAD vs DATAFONO)
                  // CORRECCIÓN CASO 01: Agregar callback onComplete para redirección después de impresión
                  this.imprimirJustificanteDevolucion(item.DatosResult.NumAlbaran, 'PARCIAL', albaranOriginal, () => {
                    this.albaranService.refrescarAlbaran(oldNumAlbaran).subscribe(() => {
                      this.albaranService.anulacionTotal.next(false);
                      this.devolucionService.setCarritoDevolucion(null);
                      this.devolucionService.setItemsSeleccionados(null);
                      this.devolucionService.setPagoTotal(null);
                      this.devolucionService.setPagoDesglosado(null);
                      this.devolucionService.setDiferencia(null);
                      this.devolucionService.setCambio(null);
                      this.router.navigate(['gestionar-venta']).then(() => {
                      }).catch((error) => {
                      });
                    }, (error) => {
                    });
                  });
                }
              } else {
                // Evita quedarse bloqueado cuando la API no devuelve DatosResult.
                this.habilitarDevolucion = true;
                const msg =
                  item?.Mensajes?.[0]?.DescripcionMensaje ||
                  this.translateService.instant('ERROR_GENERICO') ||
                  'Error al procesar la devolución';
                this.toast.error(msg, '', { toastComponent: ErrorToast });
              }
            }, (error) => {
              // Evita quedarse bloqueado en errores de red/backend.
              this.habilitarDevolucion = true;
              const msg =
                error?.error?.Mensajes?.[0]?.DescripcionMensaje ||
                error?.message ||
                this.translateService.instant('ERROR_GENERICO') ||
                'Error al procesar la devolución';
              this.toast.error(msg, '', { toastComponent: ErrorToast });
            });
        });
    } else {
      const res: any = await this.albaranService.devolucionParcial(
        this.devolucionService.itemsSeleccionadosValue
      );
      if (res.DatosResult) {
        // Llamar a GenerarPDF en TODAS las situaciones de devolución
        if (res.DatosResult.FacturaSerie && res.DatosResult.FacturaNumero) {
          // Con factura: usar serie y número específicos
          this.facturaService.generarPDFFacturaDevolucion(
            res.DatosResult.FacturaSerie,
            res.DatosResult.FacturaNumero
          ).subscribe(() => {
            this.albaranService
              .refrescarAlbaran(this.albaranService.albaranValue.NumAlbaran)
              .subscribe();
            this.albaranService.anulacionTotal.next(false);
            this.devolucionService.setCarritoDevolucion(null);
            this.devolucionService.setItemsSeleccionados(null);
            this.devolucionService.setPagoTotal(null);
            this.devolucionService.setPagoDesglosado(null);
            this.devolucionService.setDiferencia(null);
            this.devolucionService.setCambio(null);
            this.router.navigate(['gestionar-venta']);
          });
        } else {
          // Sin factura: usar endpoint de justificante (como anulación)
          this.facturaService.generarPDFJustificanteDevolucion(
            res.DatosResult.NumAlbaran
          ).subscribe(() => {
            this.albaranService
              .refrescarAlbaran(this.albaranService.albaranValue.NumAlbaran)
              .subscribe();
            this.albaranService.anulacionTotal.next(false);
            this.devolucionService.setCarritoDevolucion(null);
            this.devolucionService.setItemsSeleccionados(null);
            this.devolucionService.setPagoTotal(null);
            this.devolucionService.setPagoDesglosado(null);
            this.devolucionService.setDiferencia(null);
            this.devolucionService.setCambio(null);
            this.router.navigate(['gestionar-venta']);
          });
        }
      }
    }
  }

  imprimirJustificanteDevolucion(NumAlbaran: string, tipo: string, albaranOriginal?: any, onComplete?: () => void) {
    // Guardar referencia al albarán original para verificar tipo de pago
    const albaranOrigen = albaranOriginal || this.albaranService.albaranValue;
    
    // Verificar si el pago original fue con tarjeta PINPAD (no DATAFONO)
    // Según el código: TieneLectorElectronico === 'True' = PINPAD, TieneLectorElectronico === 'False' = DATAFONO
    // PINPAD debe llamar a GenerarTarjetaPDF, DATAFONO no debe llamar a ningún método
    const esPagoConPinpad = albaranOrigen?.TienePagoCC === '1' && 
                           albaranOrigen?.PagoCCInfo?.TieneLectorElectronico === 'True';
    
    // Si es pago con PINPAD, llamar a GenerarTarjetaPDF
    if (esPagoConPinpad) {
      // Actualizar datosTarjeta con el NumAlbaran de la devolución antes de llamar a impresionTarjeta
      this.albaranService.refrescarAlbaran(NumAlbaran).subscribe(res => {
        if (res) {
          // Actualizar datosTarjeta con el NumAlbaran del albarán de devolución
          if (!this.pagoService.datosTarjeta) {
            this.pagoService.datosTarjeta = {} as any;
          }
          this.pagoService.datosTarjeta.NumAlbaran = NumAlbaran;
          this.pagoService.datosTarjeta.Identificador = this.albaranService.albaranValue.NumVenta || NumAlbaran;
          
          const tpvId = this.albaranService.albaranValue.TPVId || 'TPV';
          const numVenta = this.albaranService.albaranValue.NumVenta || NumAlbaran;
          const nombreIdentificador = `${tpvId} - ${numVenta}`;
          
          // Llamar a GenerarTarjetaPDF para imprimir el justificante de devolución con tarjeta
          // Esto llama a /api/Justificante/GenerarTarjetaPDF
          this.pagoService.impresionTarjeta(nombreIdentificador).subscribe(
            (response) => {
              // CORRECCIÓN CASO 01: Ejecutar callback onComplete después de impresión exitosa
              if (onComplete) {
                onComplete();
              }
            },
            (error) => {
              // CORRECCIÓN CASO 01: Ejecutar callback onComplete incluso si hay error en la impresión
              if (onComplete) {
                onComplete();
              }
            }
          );
        } else {
          // CORRECCIÓN CASO 01: Ejecutar callback onComplete incluso si refrescarAlbaran retorna null/undefined
          if (onComplete) {
            onComplete();
          }
        }
      }, (error) => {
        // CORRECCIÓN CASO 01: Ejecutar callback onComplete incluso si refrescarAlbaran falla
        if (onComplete) {
          onComplete();
        }
      });
      return;
    }
    
    // Si es DATAFONO, no hacer nada (el datáfono imprime por sí mismo)
    if (albaranOrigen?.TienePagoCC === '1' && 
        albaranOrigen?.PagoCCInfo?.TieneLectorElectronico === 'False') {
      // En este caso el justificante lo imprime el datáfono, pero la navegación
      // debe ocurrir igualmente para no dejar la UI bloqueada en la pantalla de devolución.
      if (onComplete) {
        onComplete();
      }
      return;
    }
    
    // Para pago metálico u otros, usar el método normal de impresión
    // TODO  Yaribel 20201124 mejorar mapear el objeto y no usar refrescarAlbaran
    this.albaranService.refrescarAlbaran(NumAlbaran).subscribe(res => {
      if (res) {
        const albaranValue = this.albaranService.albaranValue;
        const NombreTPV = this.albaranService.albaranValue.NombreTPV;
        const IdTPV = this.albaranService.albaranValue.IdTPV;
        this.pagoService.datosCabecera().pipe(take(1)).subscribe(data => {
          switch (tipo) {
            case 'TOTAL' :
              this.printService.printRefundAlbaran({
                datos: albaranValue,
                NombreTPV: NombreTPV,
                IdTPV: IdTPV
              }, data);
              break;
            case 'PARCIAL':
              this.printService.printPartialRefund({
                datos: albaranValue
              }, data);
              break;
          }
          // CORRECCIÓN CASO 01: Ejecutar callback onComplete después de imprimir
          if (onComplete) {
            onComplete();
          }
        }, (error) => {
          // CORRECCIÓN CASO 01: Ejecutar callback onComplete incluso si datosCabecera falla
          if (onComplete) {
            onComplete();
          }
        });

      } else {
        // CORRECCIÓN CASO 01: Ejecutar callback onComplete incluso si refrescarAlbaran retorna null/undefined
        if (onComplete) {
          onComplete();
        }
      }

    }, (error) => {
      // CORRECCIÓN CASO 01: Ejecutar callback onComplete incluso si refrescarAlbaran falla
      if (onComplete) {
        onComplete();
      }
    });


  }

  getNombreCliente() {
    if (this.albaranService.albaranValue.AlbaranCliente && this.albaranService.albaranValue.AlbaranCliente[0]) {
      return `${this.albaranService.albaranValue.AlbaranCliente[0].NombreCliente}`;
    }
    return '';
  }

  getLocalizador() {
    return this.albaranService.albaranValue.Localizador
      ? this.albaranService.albaranValue.Localizador
      : '';
  }


  filtrarRecintos(recintos) {

    const recintosFiltrados: AlbaranRecinto[] = [];
    if (recintos && recintos != undefined && recintos != null && recintos.length > 0) {
      let index = 0;
      recintos.forEach((element) => {
        if (!recintosFiltrados.find(x => x.RecintoId == element.RecintoId && x.FechaEntrada == element.FechaEntrada && x.Espectaculo == element.Espectaculo && x.NumButaca == element.NumButaca && x.NumFila == element.NumFila)) {
          recintosFiltrados.push(element);
          recintosFiltrados[index].pkId = '';
          index++;
        }
        // recintosFiltrados.push({Espectaculo: element.Espectaculo, FechaEntrada: element.FechaEntrada, RecintoNombre: element.RecintoNombre, NombreGuia: element.NombreGuia,
        // NumButaca: element.NumButaca, NumFila: element.NumFila, CantidadTotal: element.CantidadTotal});

      });
      // return this.groupBy(recintosFiltrados, c=> c.RecintoId);
      // return this.removeDuplicates(recintosFiltrados, 'RecintoId');
    }
    return recintosFiltrados;
  }

  groupBy(xs, f) {
    return xs.reduce(
      (r, v, i, a, k = f(v)) => ((r[k] || (r[k] = [])).push(v), r),
      {}
    );
  }

  removeDuplicates(myArr, prop) {
    return myArr.filter((obj, pos, arr) => {
      return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
  }

}
